import { render } from "./LeftMenuPrepend.vue?vue&type=template&id=0e28b6f2&scoped=true"
import script from "./LeftMenuPrepend.vue?vue&type=script&lang=js"
export * from "./LeftMenuPrepend.vue?vue&type=script&lang=js"

import "./LeftMenuPrepend.vue?vue&type=style&index=0&id=0e28b6f2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e28b6f2"]])

export default __exports__